import { Flex, Text } from "@chakra-ui/react";
import IconBox from "components/icons/IconBox";
import { IconArrowDown } from "components/icons/Icons";

export default function AddNewCardToggle(props: { open: boolean; onToggle: () => void; isDisabled?: boolean }) {
  const { open, onToggle, isDisabled } = props;

  return (
    <Flex
      mt="14px"
      alignItems="center"
      w="fit-content"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      opacity={isDisabled ? 0.6 : 1}
      onClick={() => {
        if (isDisabled) return;
        onToggle();
      }}
    >
      <Text
        fontSize="14px"
        lineHeight="22px"
        textDecoration="underline"
        fontWeight="600"
        color="#111827"
      >
        Add new credit card
      </Text>
      <IconBox
        ml="10px"
        w="18px"
        h="18px"
        icon={
          <IconArrowDown
            w="18px"
            h="18px"
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          />
        }
      />
    </Flex>
  );
}
